export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5253.51d22c38.jpg";